import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9efd03b8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "company-detail-wrap" }
const _hoisted_2 = { class: "company-detail-banners" }
const _hoisted_3 = { class: "company-detail-box" }
const _hoisted_4 = { class: "company-detail-box-logo" }
const _hoisted_5 = ["href"]
const _hoisted_6 = ["innerHTML"]

import store from "@/store/index";
import { useStore } from "@/store/index";
import { ref, reactive } from "vue";
import Bottom from '../components/bottom.vue';
import Happy from '../components/happy.vue';
import { ElButton, ElMessage, ElMessageBox } from "element-plus";
import type { ElForm, Action } from "element-plus";
import router from "@/router/index";

interface Company {
  type: number;
  code: string;
  name: string;
  shortName: string;
  licenseNo: string;
  licenseFile: string;
  logo: string;
  brandLogo: string;
  brandBigLogo: string;
  brandName: string;
  contact: string;
  mobile: string;
  tel: string;
  companyAreaIds: string;
  companyAreaIdList: string[];
  companyFace: string;
  remark: string;
  website: string;
  province: string;
  city: string;
  area: string;
  address: string;
  corporateRepresentative: string;
  registeredFund: number;
  industry: string;
  businessCategory: string;
  teamSize: number;
  handbagCertificateLevel: string;
  storefront: string;
  licenseFileFullPath: string;
  logoFullPath: string;
  brandBigLogoFullPath: string;
  brandLogoFullPath: string;
  areaId: string;
  isPublic: string;
}


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const company: Company = {
  type: 2,
  code: "",
  name: "",
  shortName: "",
  licenseNo: "",
  licenseFile: "",
  logo: "",
  brandLogo: "",
  brandBigLogo: "",
  brandName: "",
  contact: "",
  mobile: "",
  tel: "",
  companyAreaIds: "",
  companyAreaIdList: [],
  companyFace: "",
  remark: "",
  website: "",
  province: "",
  city: "",
  area: "",
  address: "",
  corporateRepresentative: "",
  registeredFund: 0,
  industry: "",
  businessCategory: "",
  teamSize: 0,
  handbagCertificateLevel: "",
  storefront: "",
  licenseFileFullPath: "",
  logoFullPath: "",
  brandBigLogoFullPath: "",
  brandLogoFullPath: "",
  areaId: "",
  isPublic: "",
};

const ustore = useStore();
const bindData = reactive({
  companyInfo: company,
});

var id = router.currentRoute.value.params.id;

const loadData = () => {
  store.dispatch("frontCompanyModule/getCompany", { companyCode: id }).then(
    (data) => {
      //成功
      bindData.companyInfo = data.result;
    },
    (error) => {
      ElMessageBox.alert(error.msg, "系统消息", {
        confirmButtonText: "关闭",
        callback: (action: Action) => { },
      });
    }
  );
};

loadData();


return (_ctx: any,_cache: any) => {
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_el_image, {
          class: "company-detail-banners-img",
          src: require('@/assets/fd/company/u1619.jpg')
        }, null, 8, ["src"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_form, { "label-width": "120px" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "经营品牌" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_component_el_image, {
                    src: _unref(bindData).companyInfo.brandLogoFullPath
                  }, null, 8, ["src"]),
                  _createElementVNode("div", null, _toDisplayString(_unref(bindData).companyInfo.brandName), 1)
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_form, { "label-width": "120px" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "企业简称" }, {
              default: _withCtx(() => [
                _createElementVNode("span", null, _toDisplayString(_unref(bindData).companyInfo.shortName), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_form, { "label-width": "120px" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "企业信用代码" }, {
              default: _withCtx(() => [
                _createElementVNode("span", null, _toDisplayString(_unref(bindData).companyInfo.licenseNo), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_form, { "label-width": "120px" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "企业官网" }, {
              default: _withCtx(() => [
                _createElementVNode("a", {
                  href: _unref(bindData).companyInfo.website
                }, _toDisplayString(_unref(bindData).companyInfo.website), 9, _hoisted_5)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_form, { "label-width": "120px" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "企业地址" }, {
              default: _withCtx(() => [
                _createElementVNode("span", null, _toDisplayString(_unref(bindData).companyInfo.province) + "." + _toDisplayString(_unref(bindData).companyInfo.city) + "." + _toDisplayString(_unref(bindData).companyInfo.area) + "." + _toDisplayString(_unref(bindData).companyInfo.address), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_form, { "label-width": "120px" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "法人代表" }, {
              default: _withCtx(() => [
                _createElementVNode("span", null, _toDisplayString(_unref(bindData).companyInfo.corporateRepresentative), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_form, { "label-width": "120px" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "注册资金" }, {
              default: _withCtx(() => [
                _createElementVNode("span", null, _toDisplayString(_unref(bindData).companyInfo.registeredFund) + "万人民币", 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_form, { "label-width": "120px" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "联系人" }, {
              default: _withCtx(() => [
                _createElementVNode("span", null, _toDisplayString(_unref(bindData).companyInfo.contact), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_form, { "label-width": "120px" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "经营品类" }, {
              default: _withCtx(() => [
                _createElementVNode("span", null, _toDisplayString(_unref(bindData).companyInfo.businessCategory), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_form, { "label-width": "120px" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "公司介绍" }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  innerHTML: _unref(bindData).companyInfo.remark
                }, null, 8, _hoisted_6)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _createVNode(Happy, { class: "company-detail-happy" })
    ]),
    _createVNode(Bottom, { class: "company-detail-bottom" })
  ]))
}
}

})